import React, { useEffect, useState } from "react";
import "./styles.scss";
import "../AddForm1/form.scss";
import { Button, Collapse, Empty } from "antd";
import {
  FileOutlined,
  FileWordOutlined,
  FilePdfOutlined,
  FilePptOutlined,
  FileJpgOutlined,
  FileDoneOutlined,
  SolutionOutlined,
  CloudUploadOutlined,
  CheckCircleFilled,
  ExclamationCircleFilled,
} from "@ant-design/icons";
import Box from "@mui/material/Box";
import ModalDoc from "../Modal/ModalDoc";
import { useDispatch, useSelector } from "react-redux";
import { modaldocReducer } from "../../Redux/Reducers/Modal/modaldoc";
import { List } from "antd";
import Delete from "../../assets/icon/delete.svg";
import Edit from "../Icons/Edit";
import Dowolland from "../Icons/Dowolland";
import { fileReducer } from "../../Redux/Reducers/Document/document";
import { Steps } from "antd";
import { withTranslation } from "react-i18next";
import MainHeader from "../MainHeader/MainHeader";
import axios from "axios";
import url from "../../url.json";
import headers from "../../config/headers";
import {
  useNavigate,
  useSearchParams,
  createSearchParams,
} from "react-router-dom";
import ModalDocDel from "../Modal/ModalDocDel";
import ModalDocEdit from "../Modal/ModalDocEdit";
import { CaretRightOutlined } from "@ant-design/icons";
import { toast } from "react-toastify";
import DocumentShow from "./DocumentShow";
const { Panel } = Collapse;
const { Step } = Steps;
function Document({ t }) {
  const lan = useSelector((state) => state.langReducer);
  const [datares, setDatares] = useState();
  const [searchParams, setSearchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [documents, setDocument] = useState();
  const modaldoc = useSelector((state) => state.modaldoc);
  axios.defaults.headers.common[
    "Authorization"
  ] = `Bearer ${localStorage.getItem("token")}`;
  const [shows, setShows] = useState(false);
  const [showse, setShowse] = useState(false);
  const [checks, setChecks] = useState();
  const [activekey, setactivekey] = useState(false);
  useEffect(() => {
    axios
      .get(
        url.url + `/category?application_id=${localStorage.getItem("applic")}`,
        { headers: headers() }
      )
      .then((res) => {
        setDocument(res.data.data);
      });
  }, [shows, showse, modaldoc, lan]);
  const fileRef = React.createRef();
  const [file, setFile] = useState();
  const [title, settitle] = useState();
  const [categoryid, setCategoryid] = useState();
  const [activeKey, setActiveKey] = useState([
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
  ]);
  const openFile = (a, b) => {
    fileRef.current.value = "";

    settitle(a);
    setCategoryid(b);
    fileRef.current.click();
  };
  const handleCancel = () => {
    setShows(false);
    setFile();
    fileRef.current.value = "";
    dispatch(modaldocReducer(false));
  };
  const handleCancele = () => {
    setShowse(false);
    setFile();
    fileRef.current.value = "";
  };
  function handleChange(event) {
    setFile(event.target.files[0]);
    if (event.target.files[0]) {
      showModal();
    }
  }
  useEffect(() => {
    dispatch(fileReducer(file));
  }, [file]);
  const showModal = () => {
    dispatch(modaldocReducer(true));
  };
  const onChange = (key) => {};
  function selecticon(file) {
    if (file[file.length - 1] == "jpg") return <FileJpgOutlined />;
    if (file[file.length - 1] == "pdf") return <FilePdfOutlined />;
    if (file[file.length - 1] == "doc") return <FileWordOutlined />;
    if (file[file.length - 1] == "docx") return <FileWordOutlined />;
    if (file[file.length - 1] == "ppt") return <FilePptOutlined />;
    if (file[file.length - 1] == "pptx") return <FilePptOutlined />;
    else return <FileOutlined />;
  }

  const genExtra = (a, b) => (
    <div onClick={(e) => e.stopPropagation()}>
      {
        <div
          onClick={() => {
            openFile(a, b);
          }}
          className="btn btn-primary btn-sm"
        >
          {t("Add")}
        </div>
      }
    </div>
  );
  const handleNext = () => {
    const data = { id: searchParams.get("id") };
    axios
      .get(url.url + `/check`, { headers: headers(), params: data })
      .then((res) => {
        if (res.data.data?.error) {
          for (let i in res.data.data?.message) {
            toast.error(res.data.data?.message[i]);
          }
        } else {
          toast.success(res.data.data?.message);
          navigate("/account/applications");
        }
        setChecks(res.data.data);
      });
  };
  const fileKind = (name) => {
    const ext = String(name ?? "").split(".").pop().toLowerCase();
    if (ext === "pdf") return "pdf";
    if (["doc", "docx"].includes(ext)) return "word";
    if (["ppt", "pptx"].includes(ext)) return "ppt";
    if (["jpg", "jpeg", "png"].includes(ext)) return "img";
    return "other";
  };

  const [dragOver, setDragOver] = useState(null);
  const handleDrop = (e, description, id) => {
    e.preventDefault();
    setDragOver(null);
    const dropped = e.dataTransfer.files?.[0];
    if (!dropped) return;
    settitle(description);
    setCategoryid(id);
    setFile(dropped);
    showModal();
  };

  const dropZone = (res, compact) => (
    <button
      type="button"
      className={[
        "doc-drop",
        compact ? "doc-drop--compact" : "",
        dragOver === res.id ? "doc-drop--over" : "",
      ].join(" ")}
      onClick={() => openFile(res?.description, res.id)}
      onDragOver={(e) => {
        e.preventDefault();
        if (dragOver !== res.id) setDragOver(res.id);
      }}
      onDragLeave={() => setDragOver(null)}
      onDrop={(e) => handleDrop(e, res?.description, res.id)}
    >
      <CloudUploadOutlined />
      <span>
        {t("drop_file")} <u>{t("drop_file_browse")}</u>
      </span>
    </button>
  );

  function lists(res, i) {
    const dataval = res.files.map((item) => {
      const file = item?.file.split(".");
      return { obj: item, icon: selecticon(file), kind: fileKind(item?.file) };
    });

    return (
      <>
        {dataval.length ? (
          <div className="doc-files">
            {dataval.map((item) => (
              <div className="doc-file" key={item.obj.id ?? item.obj.file}>
                <span className={`doc-file__icon doc-file__icon--${item.kind}`}>
                  {item.icon}
                </span>
                <div className="doc-file__body">
                  <a
                    className="doc-file__name"
                    href={item.obj?.file}
                    target="blank"
                    title={item.obj.name}
                  >
                    {item.obj.name}
                  </a>
                  <span className="doc-file__meta">
                    {item.kind === "other"
                      ? t("File")
                      : String(item.obj?.file ?? "").split(".").pop().toUpperCase()}
                    {item.obj?.status == 2 ? (
                      <span className="doc-status doc-status--bad">
                        {t("File_rejected")}
                      </span>
                    ) : item.obj?.status == 4 ? (
                      <span className="doc-status doc-status--ok">
                        {t("File_approved")}
                      </span>
                    ) : null}
                  </span>
                </div>
                <div className="doc-file__actions">
                  <button
                    type="button"
                    title={t("Edit")}
                    onClick={() => {
                      setActiveKey(`${i}`.toString());
                      setShowse(true);
                      setDatares(item);
                    }}
                  >
                    <Edit width={16} height={16} />
                  </button>
                  <a href={item.obj?.file} target="blank" title={t("Download")}>
                    <Dowolland width={16} height={16} />
                  </a>
                  <button
                    type="button"
                    className="doc-file__del"
                    title={t("Delete")}
                    onClick={() => {
                      setShows(true);
                      setDatares(item);
                    }}
                  >
                    <img src={Delete} alt="delete icon" />
                  </button>
                </div>
              </div>
            ))}
          </div>
        ) : null}
        {dropZone(res, dataval.length > 0)}
      </>
    );
  }
  const [editable, setEditable] = useState(false);

  useEffect(() => {
    axios
      .get(url.url + `/application/${searchParams.get("id")}`, {
        headers: headers(),
      })
      .then((res) => {
        if (res.data.data.editable == 1) setEditable(true);
      });
  }, [lan]);

  return (
    <div>
      <ModalDocDel show={shows} handleCancel={handleCancel} res={datares} />
      <ModalDocEdit show={showse} handleCancel={handleCancele} res={datares} />

      <MainHeader title={t("Edit application")} />
      <div className="add-application">
        <Box sx={{ width: "100%" }}>
          <Steps>
            <Step
              status="finish"
              title={t("Application")}
              icon={<SolutionOutlined />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (searchParams.get("con_id"))
                  navigate({
                    pathname: "/account/applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                      con_id: searchParams.get("con_id"),
                    })}`,
                  });
                else
                  navigate({
                    pathname: "/account/applications/edit",
                    search: `?${createSearchParams({
                      id: searchParams.get("id"),
                    })}`,
                  });
              }}
            />
            <Step
              status="finish"
              title={t("Instruction")}
              icon={<FileDoneOutlined />}
              style={{ cursor: "pointer" }}
              onClick={() => {
                if (!editable) {
                  if (searchParams.get("con_id"))
                    navigate({
                      pathname: "/account/applications/instruction",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                        con_id: searchParams.get("con_id"),
                      })}`,
                    });
                  else
                    navigate({
                      pathname: "/account/applications/instruction",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                      })}`,
                    });
                } else {
                  if (searchParams.get("con_id"))
                    navigate({
                      pathname: "/account/applications/instruction",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                        con_id: searchParams.get("con_id"),
                      })}`,
                    });
                  else
                    navigate({
                      pathname: "/account/applications/instruction",
                      search: `?${createSearchParams({
                        id: searchParams.get("id"),
                      })}`,
                    });
                }
              }}
            />
            <Step
              status="process"
              title={t("Document")}
              icon={<FileWordOutlined />}
              style={{ cursor: "pointer" }}
            />
          </Steps>
        </Box>
      </div>
      <ModalDoc
        handleCancel={handleCancel}
        file={file}
        title={title}
        categoryid={categoryid}
      />
      <input
        type="file"
        id="file"
        ref={fileRef}
        onChange={handleChange}
        style={{ display: "none" }}
      />
      {editable ? (
        <section className="af-card doc-card">
          <div className="af-card__head">
            <div className="af-card__title">
              <span className="af-card__num">
                <FileWordOutlined />
              </span>
              <h5>{t("Document")}</h5>
            </div>
            {documents?.length
              ? (() => {
                  const done = documents.filter((d) => d.files?.length).length;
                  const pct = done / documents.length;
                  const c = 2 * Math.PI * 18;
                  return (
                    <div className="doc-ring">
                      <svg width="44" height="44" viewBox="0 0 44 44">
                        <circle cx="22" cy="22" r="18" className="doc-ring__bg" />
                        <circle
                          cx="22"
                          cy="22"
                          r="18"
                          className={
                            pct === 1
                              ? "doc-ring__val doc-ring__val--full"
                              : "doc-ring__val"
                          }
                          strokeDasharray={c}
                          strokeDashoffset={c * (1 - pct)}
                        />
                      </svg>
                      <div>
                        <b>
                          {done}/{documents.length}
                        </b>
                        <span>{t("sections_filled")}</span>
                      </div>
                    </div>
                  );
                })()
              : null}
          </div>

          <div className="doc-list">
            {documents?.map((res, i) => {
              const short = String(res.name ?? "").length <= 4;
              const count = res.files?.length || 0;
              return (
                <div
                  className={count ? "doc-cat doc-cat--done" : "doc-cat"}
                  key={res.id ?? i}
                >
                  <div className="doc-cat__head">
                    <span className="doc-cat__num">
                      {short ? res.name : i + 1}
                      {count ? (
                        <CheckCircleFilled className="doc-cat__tick" />
                      ) : null}
                    </span>
                    <div
                      className="doc-cat__title"
                      title={`${res.name}. ${res?.description}`}
                    >
                      {short ? res?.description : `${res.name}. ${res?.description}`}
                    </div>
                    <span
                      className={count ? "doc-count doc-count--ok" : "doc-count"}
                    >
                      {count ? null : <ExclamationCircleFilled />}
                      {count}
                    </span>
                  </div>
                  {lists(res, i + 1)}
                </div>
              );
            })}
          </div>
          {documents && !documents.length ? (
            <Empty description={t("No data")} />
          ) : null}
        </section>
      ) : (
        <DocumentShow />
      )}

      <div className="af-actions">
        <div className="af-actions__buttons af-actions__buttons--left">
          <Button size="large" onClick={() => navigate(-1)}>
            ← {t("last stage")}
          </Button>
        </div>
        {editable ? (
          <div className="af-actions__buttons">
            <Button
              size="large"
              onClick={() => navigate("/account/applications")}
            >
              {t("Cancel")}
            </Button>
            <Button type="primary" size="large" onClick={handleNext}>
              {t("Submit application")}
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}
export default withTranslation()(Document);
